import {
  SupplyIntelBrandRowSchema,
  SupplyIntelBrandSortKey,
  SupplyIntelUnitTotalsSchema,
  SupplyIntelWarehouseSchema,
} from "@redotech/redo-inventory-common/supply-intel/brand-list";
import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import { createTableSortSchema } from "@redotech/redo-views-common/table";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/** Returned units on Redo's shelves, one row per brand, from a cached Snowflake snapshot. */
export const getSupplyIntelBrands = unaryRpc({
  name: "getSupplyIntelBrands" as const,
  input: z.object({
    search: z.string().optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
    sort: createTableSortSchema(z.enum(SupplyIntelBrandSortKey)).optional(),
    page: z.number().int().min(0).default(0),
    pageSize: z.number().int().min(1).max(500).default(50),
    /** Start a rebuild in the background; honored at most once every 10 minutes. */
    refresh: z.boolean().default(false),
  }),
  output: z.object({
    /** Null until the first snapshot is built. */
    page: z
      .object({
        rows: z.array(SupplyIntelBrandRowSchema),
        totalCount: z.number(),
        /** Totals over every brand that matches the search and filters. */
        summary: SupplyIntelUnitTotalsSchema,
        /** Every currency a unit in the snapshot is priced in. */
        currencies: z.array(z.string()),
        /** Every warehouse a unit in the snapshot is in, for the warehouse filter. */
        warehouses: z.array(SupplyIntelWarehouseSchema),
        dataAsOf: z.date(),
        configVersion: z.string(),
        /** The snapshot hit its row limit, so some units are missing. */
        truncated: z.boolean(),
      })
      .nullable(),
    /** When the build in progress started, if one is running. */
    buildStartedAt: z.date().nullable(),
  }),
});
